module.exports = __webpack_public_path__ + "static/licha-01453ed45df147e3e49963704d3e8956.jpg";